export default __webpack_public_path__ + "static/media/bannerimg.c9753e75.png";